import React, { forwardRef } from 'react';
import styles from './checkbox.module.css';
import { Label } from '../label/label';
import classNames from 'classnames';

// Extend the props to include all input attributes
interface CheckboxListProps extends React.HTMLAttributes<HTMLDivElement> {
  direction?: 'horizontal' | 'vertical';
  label: string;
}

export const CheckboxList = forwardRef<HTMLInputElement, CheckboxListProps>(
  ({ className, children, label, direction = 'horizontal', ...props }, ref) => {
    return (
      <div>
        <Label className={styles.listLabel}>{label}</Label>
        <div
          className={classNames(styles.checkboxList, className, {
            [styles.checkboxList__horizontal]: direction === 'horizontal',
            [styles.checkboxList__vertical]: direction === 'vertical',
          })}
          {...props}
        >
          {children}
        </div>
      </div>
    );
  }
);
